var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlecheTitre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21 60.5",
    style: {
      enableBackground: "new 0 0 21 60.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DDDDDD;}\n\t.st1{fill:#FFFFFF;stroke:#EF7E60;stroke-miterlimit:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fleche") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2_1_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "5.5,60.5 19.4,30.3 5.5,0 1,0 1,60.5  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "0.4,60.5 14.4,30.3 0.4,0  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecheTitre);
export default __webpack_public_path__ + "static/media/fleche-titre.74fb0c57eb7693742b98cb7ec5134ce5.svg";
export { ForwardRef as ReactComponent };